import { render, staticRenderFns } from "./AllocationSelector.vue?vue&type=template&id=042177c2&scoped=true&"
import script from "./AllocationSelector.vue?vue&type=script&lang=js&"
export * from "./AllocationSelector.vue?vue&type=script&lang=js&"
import style0 from "./AllocationSelector.vue?vue&type=style&index=0&id=042177c2&prod&lang=scss&"
import style1 from "./AllocationSelector.vue?vue&type=style&index=1&id=042177c2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "042177c2",
  null
  
)

export default component.exports